module.exports = __webpack_public_path__ + "static/media/Raleway-SemiBold.5a25c50b.ttf";